<template>
  <div class="col-12">
    <div class="text-center" v-show="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <div v-show="!isLoading">
      <EditPersonForm
        :item="item"
        :permissionButton="showPermissionButton"
        :code="code"
        :isMyProfile="isMyProfile"
        :keyServies="`person`"
        @additem="save"
        @removeImage="removeImage"
        @cancel="cancel"
        @uploadClose="uploadClose"
        @getProfile="getProfile"
        :parentPermissions="parentPermissions"
      />
    </div>

    <confirm
      :title="modalTitle"
      :description="message"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="okConfim"
      @cancel="cancelConfim"
    ></confirm>
  </div>
</template>
<script>
import EditPersonForm from "../forms/editPersonForm";
import confirm from "@/components/base/confirm";
import { pathOr } from "ramda";

export default {
  name: "edit-person",
  components: {
    EditPersonForm,
    confirm,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    personItem: {
      type: Object,
      default: () => {},
    },
    showPermissionButton: {
      type: Boolean,
      default: false,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    code: {
      type: [String, Number],
      required: true,
    },
  },
  inject: ["profileRepository", "attachmentRepository"],
  data() {
    return {
      isLoading: false,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: null, // عنوان مدال
      message: null, // نمایش متن حذف فایل
    };
  },
  computed: {
    isMyProfile() {
      return this.$route.name === "profile";
    },
  },
  methods: {
    pathOr,
    cancel() {
      this.$emit("cancel");
    },
    clearModalConfirm() {
      this.modalTitle = null;
      this.message = null;
    },
    getProfile() {
      this.$emit("getProfile");
    },
    async okConfim() {
      let picture = this.personItem.attachments.find((x) => x.type == "thumb");
      const pictureId = pathOr(null, ["id"], picture);
      if (!pictureId) {
        return;
      }
      try {
        this.isLoading = true;
        let payload = {
          is_default: 0,
        };
        const response = await this.attachmentRepository.partial_edit(
          pictureId,
          payload,
          "person",
          this.code
        );
        this.getProfile();
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.showFileList = false;
        this.isLoading = false;
        this.confirmModal = false;
        this.clearModalConfirm();
      }
    },
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    async removeImage() {
      let pic =
        this.personItem &&
        this.personItem.attachments &&
        this.personItem.attachments.find((x) => x.type == "thumb");
      if (pic) {
        this.message = this.$lang.are_you_sure;
        this.modalTitle = this.$lang.remove_item;
        this.confirmModal = true;
      }
    },
    async uploadClose() {
      this.isLoading = true;
      this.getProfile();
      this.isLoading = false;
    },
    async save(item) {
      try {
        this.isLoading = true;
        let payload = item;
        const response = await this.profileRepository.edit(this.code, payload);
        this.$notify.success(response.data.message);
        this.getProfile();
      } catch (error) {
        this.$generateError(error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>